<template>
    <b-container>
        <b-row>
            <b-col cols="12" md="6" class="mb-3">
                <inter-input
                        label="Nome"
                        v-model="user.name"
                        icon="group"
                        :error="errors.name">
                </inter-input>
            </b-col>
            <b-col cols="8" md="6" class="mb-3">
                <inter-input
                        label="Cognome"
                        v-model="user.surname"
                        icon="group"
                        :error="errors.surname">
                </inter-input>
            </b-col>

        </b-row>
        <b-row class="align-items-end">
            <b-col cols="12" md="10" class="mb-3">
                <inter-input
                        label="Email"
                        v-model="user.email"
                        icon="mail"
                        :error="errors.email">
                </inter-input>
            </b-col>
            <b-col cols="12" md="auto" class="ml-auto mb-3 ">
                <swatches v-model="user.color"
                          colors="text-advanced"
                          popover-to="left"
                          :trigger-style="{ width: '60px', height: '60px' }"
                >
                </swatches>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import InterInput from "../../../components/form/inter-input/InterInput";
    import User from "@/models/User";
    import Swatches from "vue-swatches/src/Swatches";
    import _ from "lodash";

    export default {
        name: "AdminUserForm",
        components: {Swatches, InterInput},
        data() {
            return {
                errors: {},
            }
        },
        props: {
            user: {
                type: Object,
                default: () => Object.assign({}, User)
            },

        },
        methods: {
            validate: function () {
                this.errors = {};
                if (this.user.name === '') {
                    this.errors.name = true;
                    this.$bvToast.toast('Devi inserire un nome', { title: 'Alert', variant: 'warning' });
                }
                if (this.user.surname === '') {
                    this.errors.surname = true;
                    this.$bvToast.toast('Devi inserire un cognome', { title: 'Alert', variant: 'warning' });
                }

                if (this.user.email === '') {
                    this.errors.email = true;
                    this.$bvToast.toast("Devi inserire un'email", { title: 'Alert', variant: 'warning' });
                }

                return _.isEmpty(this.errors);

            }
        }
    }
</script>

<style scoped>

</style>
